export default {
	create: 'create',
	confirm: 'confirm',
	cancel: 'cancel',
	forceClose: 'force_close'
};
